
import React from 'react';
import { VenueRecommendations as VenueRecommendationsComponent } from '@/components/venue-recommendations/VenueRecommendations';

const VenueRecommendations = () => {
  return (
    <div className="container mx-auto">
      <VenueRecommendationsComponent />
    </div>
  );
};

export default VenueRecommendations;
